import graphql__fe5722bb99b64ea05e33 from "./__generated__/HomePageRouteQuery.graphql.js";import { graphql } from "react-relay";

import AppQueryRenderer from "../AppQueryRenderer";
import HomePage from "../HomePage";

const HomePageRoute = props => {
  return (
    <AppQueryRenderer
      query={HomePageRouteQuery}
      component={HomePage}
      additionalProps={props}
    />
  );
};

const HomePageRouteQuery = graphql__fe5722bb99b64ea05e33;

export default HomePageRoute;
